import { IconButton, BUTTON_VARIANTS, BUTTON_SIZES } from 'ui/button';
import { noop } from 'utils/noop';
import { Grid24 } from 'ui/icons/aurora/24px/Grid24';
import { Table24 } from 'ui/icons/aurora/24px/Table24';

const defaultViews = {
  TABLE: 'table',
  CARD: 'card',
};

export type TableToggleProps = {
  /** sets the active view */
  setActiveView: (view: string) => void;
  /** current active view */
  activeView: string;
  /** Object holding the different views if strings used are different than default */
  views: {
    TABLE: string;
    CARD: string;
  };
};

export const TableToggle = ({
  setActiveView = noop,
  activeView,
  views = defaultViews,
  ...props
}: TableToggleProps) => {
  return (
    <IconButton
      variant={BUTTON_VARIANTS.SECONDARY}
      aria-controls="index-view-panel"
      data-test="index-view-toggle"
      id="index-view-toggle"
      onClick={() => setActiveView(activeView === views.TABLE ? views.CARD : views.TABLE)}
      role="Button"
      size={BUTTON_SIZES.LARGE}
      {...props}
    >
      {activeView === views.CARD ? (
        <Table24 data-test="index-view-table" />
      ) : (
        <Grid24 data-test="index-view-card" />
      )}
    </IconButton>
  );
};
